"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.registerFormElement = exports.renderFormItem = exports.BmFormDefault = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/taggedTemplateLiteral"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));

var _element = require("@blue/element");

var _itemRenderer = require("../item-engine/item-renderer");

var _renderLayout = require("../../layouts/render-layout");

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2.default)([" <bm-form-default .info=\"", "\"></bm-form-default> "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t\tdisplay: block;\n\t\t"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["", ""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var BmFormDefault = /*#__PURE__*/function (_BmItemElement) {
  (0, _inherits2.default)(BmFormDefault, _BmItemElement);

  var _super = (0, _createSuper2.default)(BmFormDefault);

  function BmFormDefault() {
    (0, _classCallCheck2.default)(this, BmFormDefault);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(BmFormDefault, [{
    key: "render",
    value: function render() {
      return this.html(_templateObject(), this.info ? (0, _renderLayout.renderLayout)(this.info.layout, this.info.options.items) : null);
    }
  }], [{
    key: "is",
    get: function get() {
      return 'bm-form-default';
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        info: {
          type: Object,
          attribute: false,
          reflect: false
        }
      };
    }
  }, {
    key: "styles",
    get: function get() {
      return (0, _element.css)(_templateObject2());
    }
  }]);
  return BmFormDefault;
}(_itemRenderer.BmItemElement);

exports.BmFormDefault = BmFormDefault;

var renderFormItem = function renderFormItem(info) {
  return (0, _element.html)(_templateObject3(), info);
};

exports.renderFormItem = renderFormItem;

var registerFormElement = function registerFormElement() {
  (0, _element.register)(BmFormDefault);
};

exports.registerFormElement = registerFormElement;
